import { UserConsents, SocialVendor, NonSocialVendor, ConsentData } from '@/types/consent'
import { isPurMode } from '@/utils/app/paid'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'
import { getCookieValue } from '@/utils/common'
import { getAppConfig } from '@/config/config'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __tcfapi: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _sp_: any
  }
}

const getPurUserConsents = (cookies: RequestCookie[]): UserConsents => {
  const config = getAppConfig()

  const userConsents: UserConsents = {
    facebook: false,
    instagram: false,
    tiktok: false,
    x: false,
    youtube: false,
    truthsocial: false,
    vgwort: false,
    addefend: false,
    kameleoon: false,
  }

  for (const key in config.consent.vendor.ids.social) {
    // @ts-ignore
    if (getCookieValue(cookies, config.consent.vendor.cookies[key]) == 'true') {
      userConsents[key as keyof typeof userConsents] = true
    }
  }

  return userConsents
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserConsents = (consents: any): UserConsents => {
  const config = getAppConfig()

  const userConsents: UserConsents = {
    facebook: false,
    instagram: false,
    tiktok: false,
    x: false,
    youtube: false,
    truthsocial: false,
    vgwort: false,
    addefend: false,
    kameleoon: false,
  }

  const grants = consents.grants

  if (grants) {
    for (const key in userConsents) {
      const nonSocialVendorId = config.consent.vendor.ids.nonsocial[key as NonSocialVendor]
      const socialVendorId = config.consent.vendor.ids.social[key as SocialVendor]

      if (nonSocialVendorId && grants[nonSocialVendorId]?.vendorGrant) {
        userConsents[key as keyof UserConsents] = true
      }

      if (socialVendorId && grants[socialVendorId]?.vendorGrant) {
        config.consent.vendor.ids.socialPurposes.forEach(function (id) {
          if (grants[socialVendorId].purposeGrants[id]) {
            userConsents[key as keyof UserConsents] = true
          }
        })
      }
    }
  }

  return userConsents
}

export const storeConsent = (cookies: RequestCookie[], vendor: SocialVendor) => {
  const config = getAppConfig()
  if (isPurMode(cookies)) {
    // sessioncookie
    if (config.consent.vendor.cookies[vendor])
      document.cookie = config.consent.vendor.cookies[vendor] + '=true; path=/; domain=n-tv.de'
  } else {
    if (window.__tcfapi && config.consent.vendor.ids.social[vendor]) {
      window.__tcfapi(
        'postCustomConsent',
        2,
        () => {},
        [config.consent.vendor.ids.social[vendor]],
        config.consent.vendor.ids.socialPurposes,
        [],
      )
    }
  }
}

export const evalConsent = (cookies: RequestCookie[], setConsentData: (data: ConsentData) => void) => {
  if (isPurMode(cookies)) {
    setConsentData({
      consentReady: true,
      status: 'purMode',
      userConsents: getPurUserConsents(cookies),
    })
  } else {
    if (!window.__tcfapi) {
      setConsentData({ consentReady: true, status: 'error' })
      return
    }

    window.addEventListener('sp_error', () => {
      setConsentData({ consentReady: true, status: 'error' })
      return
    })

    window.__tcfapi('addEventListener', 2, (tcData: { eventStatus: string; tcString: string }) => {
      const tcString = tcData.tcString
      if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
        window.__tcfapi(
          'getCustomVendorConsents',
          2,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (consents: any, success: boolean) => {
            if (success) {
              setConsentData({
                consentReady: true,
                status: 'success',
                tcString: tcString,
                userConsents: getUserConsents(consents),
              })
            } else {
              setConsentData({ consentReady: true, status: 'error' })
            }
          },
        )
      }
    })
  }
}

export const loadPrivacyManager = () => {
  const config = getAppConfig()
  if (window?._sp_?.gdpr?.loadPrivacyManagerModal) {
    window._sp_.gdpr.loadPrivacyManagerModal(config.consent.sourcepoint.managerId)
  }
}

export const rejectConsent = (callback?: (success: boolean) => void) => {
  if (window.__tcfapi) {
    window.__tcfapi(
      'postRejectAll',
      2,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (postRejectAllResponse: any, success: boolean) {
        if (callback) callback(success)
        if (!success) console.error('postRejectAll consent failed')
      },
    )
  }
}

export const consentMustRejected = (cookies: RequestCookie[]) => {
  const backFromUserPortal = 'bfup'
  const searchParams = new URLSearchParams(window.location.search)

  return searchParams.has(backFromUserPortal) && searchParams.get(backFromUserPortal) === 'true' && isPurMode(cookies)
}
